module.exports = __webpack_public_path__ + "img/thumb_22.96e6344a.jpg";